import { forwardRef, createElement } from "react";
import { system, typography, space, layout, flexbox, color } from "styled-system";
import styled, { css } from "styled-components";
import CopyOperation from "./copy-operation";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const other = system({
  textTransform: true,
  overflowWrap: true,
  whiteSpace: true
});
const StyledText = styled.span.withConfig({
  displayName: "text__StyledText",
  componentId: "sc-1ayw9jz-0"
})(["transition:color 0.3s;", " ", " ", " ", " ", " ", " ", " ", " h1&,h2&,h3&,h4&,h5&{font-weight:600;margin-bottom:0.5em;", "}div&,ul&,li&,p&,h1&,h2&,h3&,h4&,h5&{+ h1,+ h2,+ h3,+ h4,+ h5{margin-top:1.2em;}}code{margin:0 0.2em;padding:0.2em 0.4em 0.1em;font-size:85%;background:", ";border:1px solid ", ";border-radius:3px;}kbd{margin:0 0.2em;padding:0.15em 0.4em 0.1em;font-size:90%;background:", ";border:1px solid ", ";border-bottom-width:2px;border-radius:3px;}mark{padding:0;background:", ";color:", ";}ul,ol{margin:0 0 1em 0;padding:0;li{margin:0 0 0 20px;padding:0 0 0 4px;}}"], typography, space, layout, flexbox, color, other, p => p.disabled && css(["color:", ";cursor:not-allowed;user-select:none;"], p.theme.colors.disabled), p => p.ellipsis && css(["overflow:hidden;white-space:nowrap;text-overflow:ellipsis;span&{display:inline-block;}"]), space, p => p.theme.colors.alpha[1], p => p.theme.colors.alpha[1], p => p.theme.colors.gray[1], p => p.theme.colors.gray[4], p => p.theme.colors.mark.bg, p => p.theme.colors.mark.color);
const wrapperTags = Object.entries({
  strong: "strong",
  underline: "u",
  italic: "i",
  delete: "del",
  mark: "mark",
  code: "code",
  keyboard: "kbd"
});
function composeWrappers(props, children) {
  return wrapperTags.reduce((el, _ref) => {
    let [key, tag] = _ref;
    return props[key] ? /*#__PURE__*/createElement(tag, {}, el) : el;
  }, children);
}
export const Text = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    copyable,
    onCopy,
    color,
    children,
    ...rest
  } = _ref2;
  return /*#__PURE__*/_jsxs(StyledText, {
    ref: ref,
    ...rest,
    color: color,
    children: [composeWrappers(rest, children), copyable && /*#__PURE__*/_jsx(CopyOperation, {
      value: String(children),
      onCopy: onCopy
    })]
  });
});
export default Text;